export type ChannelDatum = {
    id: number | string;
    channelName: string; // Temperature, TemperatureRaw, FlowMA, etc.
    deviceId: string;
    deviceName: string; // Basement Sensor, Main Flow Sensor, Battery, etc.
    //deviceType: string;
    value: number | string | undefined;
    units: string;
    iconClass: string;
};

export type Metric = ChannelDatum & {
    icon: string;
    iconColor?: string;
};

export enum OnlineStatus {
    Online = 'Online',
    Offline = 'Offline',
    Pending = 'Pending',
    Unknown = 'Unknown',
}
export enum BatteryStatus {
    Alarm = 'Alarm',
    Full = 'Full',
    Unknown = 'Unknown',
}
